import { Outlet } from "react-router-dom";
import Navbar from "../components/jsx/home/Navbar";
import "../pages/user/profile/profil.css";

const UserLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="main-container">
        <Outlet />
      </div>
      <footer className="profil_footer">
        <div className="footer_bottom">
          <div className="footer_bottom_container">
            <div>
              <p>© 2024 SOMO. Tous les droits sont réservés.</p>
            </div>
            <div>
              <p>
                Conçu par <i className="icon_heart"> </i>{" "}
                <a href="http://ucodebyus.com"> UCODEBYUS</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default UserLayout;
